<mat-form-field>
  <mat-label>
    <span class="inline-label">{{
      "components.examination-not-possible.question" | translate
    }}</span>
  </mat-label>
  <mat-select
    [(ngModel)]="reason"
    (selectionChange)="updateNotPossibleReason($event.value)"
  >
    <mat-option [value]="undefined">{{
      "components.examination-not-possible.not-applicable" | translate
    }}</mat-option>
    @for (option of NOT_POSSIBLE_REASONS; track option) {
      <mat-option [value]="option">
        {{ "enums.notPossibleReason." + option | translate }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
